import { BaseService } from "@/script/core/service/BaseService";
import { CallBack, Failure, Success } from "@/script/core/service/DataService";
import { Charge, ChargeDetailEntity } from "../entity/InspectEntity";

export class ChargeService extends BaseService {
  public calculateItem(
    chargeDetail: ChargeDetailEntity,
    callBack: CallBack<ChargeDetailEntity>,
    failure?: Failure
  ) {
    const api = "/api/ins/charge/calculate_item";
    super.post(api, chargeDetail).then(
      function(result) {
        callBack(result.data);
      },
      function(error: Error) {
        if (failure) {
          failure(error);
        }
      }
    );
  }

  public calculateSum(
    charge: Charge,
    callBack: CallBack<Charge>,
    failure?: Failure
  ) {
    const api = "/api/ins/charge/calculate_sum";
    super.post(api, charge).then(
      function(result) {
        callBack(result.data);
      },
      function(error: Error) {
        if (failure) {
          failure(error);
        }
      }
    );
  }

  public audit(
    charge: Charge,
    callBack: CallBack<Charge>,
    failure?: Failure
  ) {
    const api = "/api/ins/charge/audit";
    super.post(api, charge).then(
      function(result) {
        callBack(result);
      },
      function(error: Error) {
        if (failure) {
          failure(error);
        }
      }
    );
  }
}
